.form {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.label {
  font-family: var(--token-font-ui);
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: rgba(28, 38, 32, 0.7);
}

.input {
  min-height: 42px;
  padding: 10px 14px;
  border-radius: 12px;
  border: 1px solid rgba(8, 18, 12, 0.16);
  background: rgba(255, 255, 255, 0.7);
  font-family: var(--token-font-ui);
  font-size: 15px;
  color: var(--token-text-primary);
  transition:
    border-color 120ms ease,
    background 120ms ease;
}

.input:focus {
  outline: none;
  border-color: var(--token-accent);
  background: #ffffff;
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--token-accent) 20%, transparent);
}

.error {
  margin: 0;
  font-size: 13px;
  color: #b03a2e;
}

.actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 4px;
}

.cancel {
  min-height: 40px;
  padding: 8px 16px;
  border-radius: 999px;
  border: 1px solid rgba(8, 18, 12, 0.16);
  background: transparent;
  color: var(--token-text-primary);
  font-family: var(--token-font-ui);
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: background 120ms ease;
}

.cancel:hover {
  background: rgba(8, 18, 12, 0.06);
}
